export default __webpack_public_path__ + "static/media/element_98.05050022.jpg";